import React, { useEffect, useState } from "react";
import { api, fmtUSD } from "@/lib/api";
import { Coins } from "lucide-react";

export default function FeeCounter() {
  const [data, setData] = useState({ current_fee_usd: 0, current_volume_usd: 0, current_period: "" });
  useEffect(() => {
    const load = () => api.get("/pons/fees").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 25000);
    return () => clearInterval(t);
  }, []);
  return (
    <div
      data-testid="fee-counter"
      className="inline-flex items-center gap-3 rounded-md border border-[#FFAB00]/40 bg-[#141008]/80 px-3 py-2"
    >
      <Coins className="w-4 h-4 text-[#FFC940]" />
      <div className="text-xs mono leading-tight">
        <div className="text-stone-400 uppercase tracking-widest text-[10px]">3% fee collected · {data.current_period}</div>
        <div className="text-[#FFC940] text-sm">
          {fmtUSD(data.current_fee_usd)} <span className="text-stone-500">· from {fmtUSD(data.current_volume_usd)} $QUODUST volume on Pons</span>
        </div>
      </div>
    </div>
  );
}
